import React from 'react';
import { motion } from 'framer-motion';
import { Check, Zap, Crown, Shield } from 'lucide-react';

const PlanCard = ({ title, price, features, recommended, icon: Icon, current, onSelect }) => (
  <motion.div
    whileHover={{ y: -5 }}
    className={`p-8 rounded-2xl border flex flex-col ${
      recommended
        ? 'bg-gradient-to-b from-primary/20 to-surface border-primary/50 relative overflow-hidden'
        : 'bg-surface border-white/5'
    }`}
  >
    {recommended && (
      <div className="absolute top-0 right-0 bg-primary text-white text-xs font-bold px-3 py-1 rounded-bl-xl">
        RECOMMENDED
      </div>
    )}
    <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${
      recommended ? 'bg-primary text-white' : 'bg-white/5 text-slate-400'
    }`}>
      <Icon size={24} />
    </div>
    <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
    <div className="flex items-baseline gap-1 mb-6">
      <span className="text-3xl font-bold text-white">{price}</span>
      <span className="text-slate-400">/мес</span>
    </div>
    <div className="space-y-4 mb-8 flex-1">
      {features.map((feature, i) => (
        <div key={i} className="flex items-start gap-3">
          <Check size={18} className="text-emerald-400 shrink-0 mt-0.5" />
          <span className="text-slate-300 text-sm">{feature}</span>
        </div>
      ))}
    </div>
    <button
      onClick={onSelect}
      disabled={current}
      className={`w-full py-3 rounded-lg font-bold transition-all ${
        current
          ? 'bg-emerald-500/20 text-emerald-400 cursor-default'
          : recommended
            ? 'bg-primary hover:bg-primary/90 text-white shadow-lg shadow-primary/25'
            : 'bg-white/5 hover:bg-white/10 text-white'
      }`}
    >
      {current ? 'Текущий план' : 'Выбрать тариф'}
    </button>
  </motion.div>
);

export default function Subscription() {
  const handleSelectPlan = (plan) => {
    if (plan === 'start') return;
    window.open('https://t.me/Masternobis?text=' + encodeURIComponent(`Хочу подключить тариф ${plan} на LuckStat`), '_blank');
  };

  return (
    <div className="space-y-8 max-w-6xl mx-auto">
      <div className="text-center space-y-4 mb-12">
        <h1 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-400">
          Тарифные планы
        </h1>
        <p className="text-slate-400 text-lg max-w-2xl mx-auto">
          Выберите план, который подходит для роста вашего канала. Начните бесплатно и масштабируйтесь по мере успеха.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <PlanCard
          title="Start"
          price="0 ₽"
          icon={Zap}
          current={true}
          onSelect={() => handleSelectPlan('start')}
          features={[
            "До 1 канала",
            "Базовая аналитика",
            "История за 7 дней",
            "1 пользователь"
          ]}
        />
        <PlanCard
          title="Pro"
          price="990 ₽"
          icon={Crown}
          recommended={true}
          onSelect={() => handleSelectPlan('Pro')}
          features={[
            "До 5 каналов",
            "Полная сквозная аналитика",
            "История за 90 дней",
            "Экспорт отчетов",
            "Приоритетная поддержка"
          ]}
        />
        <PlanCard
          title="Business"
          price="2990 ₽"
          icon={Shield}
          onSelect={() => handleSelectPlan('Business')}
          features={[
            "Безлимитные каналы",
            "API доступ",
            "Бесконечная история",
            "Персональный менеджер",
            "White Label отчеты"
          ]}
        />
      </div>
    </div>
  );
}
